import { render, staticRenderFns } from "./fixedDetail.vue?vue&type=template&id=c775f08c&scoped=true&"
import script from "./fixedDetail.vue?vue&type=script&lang=js&"
export * from "./fixedDetail.vue?vue&type=script&lang=js&"
import style0 from "./fixedDetail.vue?vue&type=style&index=0&id=c775f08c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c775f08c",
  null
  
)

export default component.exports